import type { commentStatus as en } from "../en/commentStatus";

/** ما حدث للتعليق ومن فعله (ALP-84). */
export const commentStatus: typeof en = {
  label: "حالة التعليق",
  who: {
    you: "أنت",
    user: "{{name}}",
    teammate: "أحد أعضاء الفريق",
    rule: "القاعدة «{{name}}»",
    ruleUnnamed: "قاعدة",
    agent: "الوكيل الذكي «{{name}}»",
    agentUnnamed: "وكيل ذكي",
    instagram: "إنستغرام",
    author: "كاتبه",
    system: "منصة ملفك",
  },
  badge: {
    deleted: "محذوف",
    hidden: "مخفي",
    replied: "تم الرد",
    privateReply: "رد برسالة خاصة",
    rule: "قاعدة",
  },
  line: {
    deleted: "حذفه {{who}}",
    deletedOnInstagram: "حُذف على إنستغرام",
    deletedByAuthor: "حذفه كاتبه",
    hidden: "أخفاه {{who}}",
    hiddenBlocked: "مخفي لأن كاتبه محظور",
    unhidden: "أظهره من جديد {{who}}",
    replied: "ردّ عليه {{who}}",
    private_reply: "ردّ عليه برسالة خاصة {{who}}",
    tagged: "وسمه {{who}} بـ«{{detail}}»",
    taggedPlain: "وسمه {{who}}",
    untagged: "أزال {{who}} الوسم",
    archived: "أرشفه {{who}}",
    unarchived: "أعاده من الأرشيف {{who}}",
    pinned: "ثبّته {{who}}",
    unpinned: "ألغى {{who}} تثبيته",
    rule: "تصرّفت {{who}} فيه",
  },
  ruleDid: {
    hide: "أخفته",
    delete: "حذفته",
    reply: "ردّت عليه",
    reply_private: "ردّت برسالة خاصة",
    flag: "وسمته",
    notify: "نبّهت الفريق",
    other: "تصرّفت فيه",
  },
  history: "ما حدث",
  noHistory: "لم يحدث شيء لهذا التعليق بعد.",
  openRule: "فتح القاعدة",
  openRun: "فتح في سجل الأتمتة",
  blocked: "الكاتب محظور",
};
